import { useGlobalQuery } from '@/state/query-client/hooks';
import { searchScopedEmployees } from '../services/leave-manager.service';
import { getLeaveOverview } from '../services/leave-overview.service';
import { useDepartmentScope } from '@/modules/shared/hr-lookups';
import { GetLeaveOverviewParams } from '../types/leave-overview.types';

export const useGetLeaveOverview = (params: GetLeaveOverviewParams) =>
  useGlobalQuery({
    queryKey: ['hr-leave-overview', params],
    queryFn: () => getLeaveOverview(params),
    staleTime: 60 * 1000,
  });

/** Resolves the Leave Overview keyword search box to matching employees within the department scope
 * (`searchScopedEmployees`); only runs once a keyword has actually been typed. */
export const useSearchLeaveOverviewEmployees = (keyword: string) => {
  // Within the department scope, like the Leave Manager's other tabs.
  const departmentCondition = useDepartmentScope().getDepartmentIdCondition('');
  return useGlobalQuery({
    queryKey: ['hr-leave-overview-employee-search', keyword, departmentCondition ?? null],
    queryFn: () => searchScopedEmployees(keyword, departmentCondition),
    enabled: keyword.trim().length > 0,
    staleTime: 60 * 1000,
  });
};
